export default __webpack_public_path__ + "static/media/blogtop.ea97ba94.jpg";